<template>
  <div class="parking-page">
    <parking-block />
    <!-- <installment-block /> -->
    <best-apartments-block />
    <callback-block id="callback" id-formblock="question-block__callback" />
  </div>
</template>

<script>
import ParkingBlock from "../components/blocks/ParkingBlock";
import CallbackBlock from "@/components/blocks/CallbackBlock";
import BestApartmentsBlock from "@/components/blocks/BestApartmentsBlock";
// import InstallmentBlock from "@/components/blocks/InstallmentBlock";

export default {
  name: "ParkingPage",
  components: {
    ParkingBlock,
    CallbackBlock,
    BestApartmentsBlock,
    // InstallmentBlock,
  },
  metaInfo: {
    meta: [
      {
        name: "description",
        content:
          "Подземный паркинг с удобным подъездом со стороны Рублевского шоссе и Кутузовского проспекта.",
      },
    ],
  },
};
</script>

<style lang="scss" scoped></style>
